class MaterialASMEII {
  
  constructor({
      materialSpecification,
      nominalComposition,
      productForm,
      alloyDesignation,
      classConditionTemper,
      pNo,
      groupNo,
      minTensileStrength,
      minYieldStrength,
      viiiApplicAndMaxTemLimit,
      rangeDesignTemperatureCelsius
    }) {
      this.materialSpecification = materialSpecification;
      this.nominalComposition = nominalComposition;
      this.productForm = productForm;
      this.alloyDesignation = alloyDesignation;
      this.classConditionTemper = classConditionTemper;
      this.pNo = Number(pNo);
      this.groupNo = Number(groupNo);

      // 🔹 Conversão correta de string → number
      this.minTensileStrength = Number(
        String(minTensileStrength).replace(',', '.')
      );

      this.minYieldStrength = Number(
        String(minYieldStrength).replace(',', '.')
      );

      this.viiiApplicAndMaxTemLimit = Number(
        String(viiiApplicAndMaxTemLimit).replace(',', '.')
      );

      this.rangeDesignTemperatureCelsius = rangeDesignTemperatureCelsius;
    }
  }

module.exports = MaterialASMEII;
